import {createUseStyles} from 'react-jss';
import MediaQueries from '../style-helper/MediaQueries';
import Width from '../style-helper/Width';
import baseInputStyles from './Form.styles';

export default createUseStyles({
  selectField: {
    ...baseInputStyles,
    padding: [0, 8],
    width: props => (props.width ? props.width : Width.twoThird),
    backgroundColor: 'transparent',
    
    // Custom styled select for Webkit based browser only
    [MediaQueries.webkit]: {
      appearance: 'none',
    },
    
    '&:invalid': {
      color: '#bbb',
    },
    
    '&.error-block-v2': {
      '&:invalid': {
        color: '#b60000',
      },
    },
  },
});
